'use client';

import { useEffect } from 'react';
import { useInstantSearch } from 'react-instantsearch';

import { logError, logInfo } from 'commons/logger';

// Render inside every <InstantSearch> tree.
const CatchAlgoliaSearchError = () => {
  const { error } = useInstantSearch({ catchError: true });

  useEffect(() => {
    if (!error) {
      return;
    }

    if (error.name === 'RetryError') {
      logInfo('Algolia search could not reach any host', error);
      return;
    }

    logError(error, { type: 'algolia-search' });
  }, [error]);

  return null;
};

export default CatchAlgoliaSearchError;
